import { useRef } from "react";
import { Route, Routes, useLocation, useNavigate } from "react-router-dom";
import { Transition, TransitionGroup } from "react-transition-group";

import {
  CancelAVisitModal,
  ChangeUserRoleModal,
  EditProviderDetailsModal,
  ProviderDetailsModal,
  UserDetailsModal,
} from "~/modals";
import { ActivityDetailModal } from "~/modals/Activity/ActivityDetailModal/ActivityDetailModal";
import { BannerDetailsModal } from "~/modals/Banner/BannerDetailsModal/BannerDetailsModal";
import { AddUserModal } from "~/modals/User/AddUserModal/AddUserModal";
import { EditCancellationReasonModal } from "~/modals/User/EditCancellationReasonModal/EditCancellationReasonModal";
import { StaffBookingDrawer } from "~/modals/User/StaffBookingDrawer/staff-booking-drawer";
import { getModalParentRoute, MODAL_ROUTES } from "./constants";

export const ModalRouter = ({ showModal }: { showModal: boolean }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const nodeRef = useRef(null);

  const { previousLocation } = (location.state ?? {}) as {
    previousLocation?: Location;
  };

  const hasNothingToPopBackTo = location.key === "default" || !previousLocation;

  return (
    <TransitionGroup>
      <Transition key={location.pathname} timeout={600} nodeRef={nodeRef}>
        {(state) => {
          const show = state !== "exited" && state !== "exiting";

          if (!showModal) return null;

          const goBack = () => {
            if (state === "exiting") return;

            if (hasNothingToPopBackTo) {
              navigate(getModalParentRoute(location.pathname), {
                replace: true,
              });
              return;
            }

            navigate(-1);
          };

          return (
            <Routes location={location}>
              <Route
                path={`${MODAL_ROUTES.userDetails}/:userId`}
                element={<UserDetailsModal show={show} onClose={goBack} />}
              />

              <Route
                path={MODAL_ROUTES.addUser}
                element={<AddUserModal show={show} onClose={goBack} />}
              />

              <Route
                path={MODAL_ROUTES.changeRole}
                element={<ChangeUserRoleModal show={show} onClose={goBack} />}
              />
              <Route
                path={MODAL_ROUTES.staffBooking}
                element={<StaffBookingDrawer show={show} onClose={goBack} />}
              />
              <Route
                path={`${MODAL_ROUTES.staffBooking}/:userId`}
                element={<StaffBookingDrawer show={show} onClose={goBack} />}
              />
              <Route
                path={`${MODAL_ROUTES.cancelAVisit}/:userId/:appointmentId`}
                element={<CancelAVisitModal show={show} onClose={goBack} />}
              />

              <Route
                path={`${MODAL_ROUTES.editCancellation}/:userId/:ehrAppointmentId`}
                element={
                  <EditCancellationReasonModal show={show} onClose={goBack} />
                }
              />

              <Route
                path={`${MODAL_ROUTES.providerDetails}/:providerId`}
                element={<ProviderDetailsModal show={show} onClose={goBack} />}
              />

              <Route
                path={`${MODAL_ROUTES.editProviderSchedule}/:providerId`}
                element={
                  <EditProviderDetailsModal show={show} onClose={goBack} />
                }
              />

              <Route
                path={`${MODAL_ROUTES.bannerDetails}/:bannerId`}
                element={<BannerDetailsModal show={show} onClose={goBack} />}
              />

              <Route
                path={`${MODAL_ROUTES.activityDetails}/:activityId`}
                element={<ActivityDetailModal show={show} onClose={goBack} />}
              />
            </Routes>
          );
        }}
      </Transition>
    </TransitionGroup>
  );
};
